import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=b7283ff4&"
import script from "./rich-editor.vue?vue&type=script&lang=js&"
export * from "./rich-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports